import Image from "next/image";

type Featured = {
  file: string;
  title: string;
  subtitle: string;
};

const featured: Featured[] = [
  {
    file: "CloudManagementPlatforms_HighPerformer_HighPerformer.svg",
    title: "High Performer",
    subtitle: "Cloud Management Platforms",
  },
  {
    file: "CloudCostManagement_HighPerformer_HighPerformer.svg",
    title: "High Performer",
    subtitle: "Cloud Cost Management",
  },
  {
    file: "CloudManagementPlatforms_BestResults_Total.svg",
    title: "Best Results",
    subtitle: "Cloud Management Platforms",
  },
  {
    file: "CloudManagementPlatforms_BestEstimatedROI_Roi.svg",
    title: "Best Estimated ROI",
    subtitle: "Cloud Management Platforms",
  },
];

export function G2Featured() {
  return (
    <div className="mt-16">
      <p className="mb-6 text-center text-[10px] uppercase tracking-widest text-muted-foreground">
        Featured G2 badges · Spring 2026
      </p>
      <div className="flex flex-wrap items-end justify-center gap-5 sm:gap-6">
        {featured.map((b) => (
          <div key={b.file} className="flex flex-col items-center text-center">
            <div className="flex h-44 w-40 items-center justify-center rounded-2xl bg-white p-4 shadow-xl shadow-black/40 transition-all hover:-translate-y-1 hover:shadow-accent/20">
              <Image
                src={`/logos/g2/${b.file}`}
                alt={`${b.title} — ${b.subtitle}`}
                width={140}
                height={155}
                className="h-full w-full object-contain"
              />
            </div>
            <div className="mt-3 text-sm font-medium text-foreground">
              {b.title}
            </div>
            <div className="text-xs text-muted-foreground">{b.subtitle}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
